<template>
	<div class="invite">
		<b-avatar-group size="28px" v-if="event">
			<template v-for="p in event.promotors">
				<b-avatar
					:key="p.id"
					v-if="p.status == 'ACTIVE'"
					:text="p.user ? p.user.initials : p.email.substring(0, 2)"
					:style="`background-color: ${p.user ? p.user.profileColor : p.profileColor}; color:#fff`"
					:button="true"
					@click="open('promotors')"
					v-b-tooltip.hover
					:title="p.user ? `${p.user.name} ${p.user.lastname}` : p.email"
				></b-avatar>
			</template>
		</b-avatar-group>

		<b-modal id="eventInvitePromotorModal" size="md" :title="title" no-close-on-backdrop hide-footer @close="close">
			<b-tabs content-class="mt-3" v-model="tabIndex">
				<b-tab title="Invitar">
					<div class="p-4" v-if="event.canEdit">
						<h6>Invitación por email</h6>

						<!-- <div class="mb-3">
							<v-select
								class="select"
								:options="options"
								placeholder="Agrega promotores al evento por nombre o por email..."
								@search="search"
								@input="selected"
								:value="form.user"
								:filterable="false"
								:clearable="false"
								:searchable="true"
								:taggable="true"
								:loading="loading"
								:filterBy="filterBy"
							>
								<template #option="option">
									<div class="item" v-if="option">
										<span>{{ option.label }} </span><br />
										<strong>{{ option.email }}</strong>
									</div>
								</template>
								<template #no-options>
									Busca un usuario existente o invita a alguien nuevo por email
								</template>
							</v-select>
						</div> -->

						<div class="mb-3">
							<FormulateInput v-model="form.user" label="Email" />
						</div>

						<div class="mb-3">
							<textarea
								v-model="form.message"
								class="form-control"
								rows="4"
								placeholder="Agrega un mensaje (opcional)"
							>
							</textarea>
						</div>

						<div class="d-flex justify-content-end">
							<div class="btn btn-primary disabled" v-if="saving">Enviando <span class="loader" /></div>
							<button class="btn btn-primary" @click="save" v-if="!saving" :disabled="!form.isValid">
								Enviar invitación
							</button>
						</div>
					</div>
					<div class="p-4" v-if="!event.canEdit">
						No puedes inivtar promotores para un evento cerrado.
					</div>
				</b-tab>

				<b-tab title="Promotores">
					<div class="p-3" v-if="event">
						<div v-for="p in activePromotors" :key="p.id">
							<div class="promotor">
								<div>
									<b-avatar
										size="36px"
										:text="p.user ? p.user.initials : p.email.substring(0, 2)"
										:style="
											`background-color: ${
												p.user ? p.user.profileColor : p.profileColor
											}; color:#fff`
										"
										:button="true"
										@click="open('promotors')"
									></b-avatar>
								</div>
								<div v-if="p.user" class="data">
									<strong>{{ p.user.name }} {{ p.user.lastname }}</strong>
									<span class="text-secondary">{{ p.user.email }}</span>
								</div>
								<div v-else class="data">
									<strong>{{ p.email }}</strong>
									<span class="text-warning">Invitación pendiente</span>
								</div>
								<div>
									<button
										v-if="event.canEdit"
										class="btn btn-xs btn-secondary"
										@click="deletePrompt(p)"
										v-b-tooltip.hover
										title="Eliminar promotor"
									>
										Eliminar
									</button>
								</div>
							</div>
						</div>

						<div class="alert alert-default text-center" v-if="activePromotors.length <= 0">
							Aún no has invitado a ningún promotor a este evento.
						</div>
					</div>
				</b-tab>
			</b-tabs>
		</b-modal>
	</div>
</template>
<script>
import gql from "graphql-tag"
export default {
	name: "EventInvitePromotor",

	props: {
		eventId: {
			type: String,
			required: true
		}
	},

	data() {
		return {
			loading: false,
			saving: false,
			opened: false,
			event: null,
			title: "Promotores RRPP",
			action: "create",
			tabIndex: 0,
			options: [],
			form: {
				user: null,
				message: "",
				isValid: false
			}
		}
	},
	computed: {
		activePromotors() {
			return this.event.promotors.filter((p) => p.status == "ACTIVE")
		}
	},
	watch: {
		form: {
			deep: true,
			handler(val) {
				if (typeof val.user === "object" && val.user && val.user.email !== null) {
					this.form.isValid = true
				} else if (typeof val.user === "string" && val.user !== null) {
					this.form.isValid = true
				} else {
					this.form.isValid = false
				}
			}
		}
	},

	async beforeMount() {
		await this.loadEvent()
	},

	methods: {
		async open(tab) {
			this.opened = true
			tab == "promotors" ? (this.tabIndex = 1) : (this.tabIndex = 0)
			this.$bvModal.show("eventInvitePromotorModal")
		},
		close() {
			this.$bvModal.hide("eventInvitePromotorModal")
			this.form = {
				user: null,
				message: "",
				isValid: false
			}
		},

		selected(val) {
			var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/

			// check if val is string
			if (typeof val === "string") {
				// estoy con un mail  a mano
				if (!val.match(validRegex)) {
					this.form.user = null
					return null
				}
			}
			if (typeof val === "object" && !val.email) {
				// estoy con un mail  a mano
				if (!val.label.match(validRegex)) {
					this.form.user = null
					return null
				}
			}

			this.form.user = val
			this.loading = false
		},
		filterBy(option, label, search) {
			return (
				(label || "").toLocaleLowerCase().indexOf(search.toLocaleLowerCase()) > -1 ||
				(option.email || "").toLocaleLowerCase().indexOf(search.toLocaleLowerCase()) > -1
			)
		},

		save() {
			if (this.form.isValid) {
				this.saving = true

				const email = typeof this.form.user === "string" ? this.form.user : this.form.user.email
				let data = {
					eventId: this.eventId,
					email,
					message: this.form.message
				}

				this.$apollo
					.mutate({
						mutation: gql`
							mutation eventPromotorInvite($eventId: ID!, $email: String!, $message: String) {
								eventPromotorInvite(eventId: $eventId, email: $email, message: $message)
							}
						`,
						variables: {
							eventId: data.eventId,
							email: data.email,
							message: data.message
						}
					})
					.then(({ data }) => {
						this.$toast.success("Invitación enviada correctamente")
						this.close()
						this.$emit("updated")
						this.loadEvent()
						this.saving = false
					})
					.catch((error) => {
						this.saving = false
						this.parseGQLErrors(error)
					})
				this.saving = false
			}
		},

		search(searchText) {
			this.loading = true
			if (searchText != "") {
				this.$apollo
					.query({
						query: gql`
							query($take: Int, $skip: Int, $search: String) {
								users(take: $take, skip: $skip, search: $search) {
									data {
										id
										name
										lastname
										email
									}
								}
							}
						`,
						variables: {
							take: 10,
							skip: 0,
							search: searchText
						},
						fetchPolicy: "no-cache"
					})
					.then(({ data }) => {
						this.options = data.users.data.map((user) => {
							return {
								id: user.id,
								label: `${user.name} ${user.lastname}`,
								email: user.email
							}
						})
						this.loading = false
					})
			}
			this.loading = false
		},

		loadEvent() {
			return this.$apollo
				.query({
					query: gql`
						query($id: ID!) {
							event(id: $id) {
								id
								canEdit
								promotors {
									id
									email
									profileColor
									status
									user {
										id
										name
										lastname
										email
										initials
										profileColor
									}
								}
							}
						}
					`,
					variables: { id: this.eventId },
					fetchPolicy: "no-cache"
				})
				.then(({ data }) => {
					this.loading = false
					this.event = data.event
					return data.event
				})
				.catch(() => {})
		},

		deletePrompt(item) {
			this.$dialog
				.confirm(
					{
						title: "Eliminar promotor",
						body: `¿Está seguro que desea eliminar del evento al promotor "<strong>${item.email}"</strong>?`
					},
					{
						okText: "Eliminar",
						customClass: "delete-prompt"
					}
				)
				.then(() => {
					this.delete(item)
				})
		},

		delete(item) {
			console.log(item)
			this.loading = true
			this.$apollo
				.mutate({
					mutation: gql`
						mutation($id: ID!) {
							eventPromotorRemove(id: $id)
						}
					`,
					variables: {
						id: item.id
					}
				})
				.then(() => {
					this.$toast.success("Promotor eliminado correctamente")
					this.loading = false
					this.loadEvent()
				})
				.catch((error) => {
					this.parseGQLErrors(error)
					this.loading = false
				})
		}
	}
}
</script>

<style scoped lang="scss">
* /deep/ .modal-body {
	padding: 0px;
}
* /deep/ .nav-tabs {
	padding: 0px 18px;
}

* /deep/ .b-avatar-group {
	.b-avatar-group-inner {
		display: initial;

		.b-avatar {
			border: 1px solid #fff;

			.b-avatar-text span {
				line-height: 12px;
			}
		}
	}
}

.promotor {
	line-height: 0.85rem;
	display: flex;
	align-items: center;
	padding: 10px;
	border-bottom: 1px solid #f3f3f3;
	.data {
		flex-grow: 1;
		margin-left: 12px;
		strong {
			display: block;
		}
	}
}
</style>
